<header class="section-header">
  <h2>الگوی 24 ساعته خودرو</h2>
  <span>میانگین ساعات هر وضعیت در یک روز</span>
</header>

<div *ngIf="hasData; else emptyPattern" class="stack" role="img" aria-label="سهم زمانی وضعیت‌های خودرو در یک روز؛ مقادیر در کارت‌های زیر نمایش داده شده‌اند">
  <div class="stack-fill">
    <div *ngFor="let state of states" class="stack-segment" [ngClass]="state.cssClass"
      [hidden]="state.percentage === 0"
      [style.width.%]="state.percentage"
      [attr.title]="state.label + ': ' + (state.hours | number:'1.2-2':'en-US') + ' ساعت'">
    </div>
  </div>
</div>
<ng-template #emptyPattern>
  <p class="empty-state" role="status">دادهٔ کافی برای نمایش الگوی روزانه وجود ندارد.</p>
</ng-template>

<dl class="time-stats">
  <div *ngFor="let state of states" class="time-stat" [ngClass]="state.cssClass">
    <dt><i class="dot" aria-hidden="true"></i>{{ state.label }}</dt>
    <dd>
      <b>{{ state.hours === null ? '—' : (state.hours | number:'1.2-2':'en-US') }}</b>
      <span>ساعت</span>
    </dd>
  </div>
</dl>

<p class="chart-note">«زمان نامشخص» به معنی فقدان شواهد کافی برای طبقه‌بندی وضعیت خودرو است؛ معادل خاموش بودن موتور نیست.</p>
